import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon, InformationCircleIcon, LightBulbIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';

const typeIcons = {
  info: <InformationCircleIcon className="h-5 w-5 text-primary-light" />,
  tip: <LightBulbIcon className="h-5 w-5 text-primary-light" />,
  warning: <ExclamationTriangleIcon className="h-5 w-5 text-primary-light" />,
};

const ExpandableCallout = ({ type = 'info', title, children, className = '', defaultOpen = true }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <aside
      className={`mt-4 mb-4 bg-gray-900/90 border border-primary/30 rounded-xl shadow-md p-5 transition hover:shadow-lg focus-within:shadow-lg dark:bg-gray-900/95 dark:border-primary/40 ${className}`}
      tabIndex={0}
      aria-expanded={open}
    >
      <button
        className="flex items-center w-full text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/70"
        onClick={() => setOpen((v) => !v)}
        aria-controls={title.replace(/\s+/g, '-').toLowerCase() + '-callout'}
        aria-expanded={open}
      >
        <span className="mr-2">{typeIcons[type]}</span>
        <span className="font-semibold text-primary-light mr-2">{title}</span>
        {open ? <ChevronUpIcon className="h-5 w-5 ml-auto text-primary-light" /> : <ChevronDownIcon className="h-5 w-5 ml-auto text-primary-light" />}
      </button>
      {open && (
        <div id={title.replace(/\s+/g, '-').toLowerCase() + '-callout'} className="mt-4 text-gray-200">
          {children}
        </div>
      )}
    </aside>
  );
};

export default ExpandableCallout; 